<template>
	<!-- Login Mobile -->
	<div class="login-mobile-container">
		<p class="body-2-bold mobile-log">{{ $t('loginPage.loginMobile') }}</p>
		<div class="social-mobile">
			<div class="social_buttons">
				<button @click="doFederatedGoogleLogIn" type="button">
					<img src="/assets/images/google.svg" alt="" class="google-icon" />
					<p>{{ $t('loginBox.logInGoogle') }}</p>
				</button>
				<button @click="doFederatedFacebookLogIn" type="button">
					<img src="/assets/images/facebook.svg" alt="" class="facebook-icon" />
					{{ $t('loginBox.logInFacebook') }}
				</button>
			</div>
		</div>
		<p class="body-2-bold mobile-or">{{ $t('loginPage.loginOr') }}</p>
	</div>

	<div class="cabinet-login-box-container">
		<div class="container-white">
			<h1 class="title-form">{{ $t('loginBox.title') }}</h1>
			<!-- Login Google and Facebook -->
			<div class="social_buttons">
				<button @click="doFederatedGoogleLogIn" type="button">
					<img src="/assets/images/google.svg" alt="" class="google-icon" />
					<p>{{ $t('loginBox.logInGoogle') }}</p>
				</button>
				<button @click="doFederatedFacebookLogIn" type="button">
					<img src="/assets/images/facebook.svg" alt="" class="facebook-icon" />
					{{ $t('loginBox.logInFacebook') }}
				</button>
			</div>

			<!-- separator -->
			<div class="or">
				<div class="or__label">{{ $t('loginBox.or') }}</div>
			</div>

			<!-- Login Email and Password -->
			<div class="inputsForm">
				<div class="form__group field">
					<TVInputBase
						id="labelled-field-email"
						v-model="email"
						type="email"
						:label="$t('loginBox.email')"
						:placeholder="$t('loginBox.placeholderEmail')"
						name="labelled-field-email"
						:error="isEmailError"
						:customErrorMessage="isEmailError ? emailErrorMessage : ''"
					/>
				</div>

				<div class="form__group field label-2">
					<TVInputPassword
						v-model="password"
						:label="$t('loginBox.password')"
						:placeholder="$t('loginBox.placeholderPassword')"
						:errorText="$t('loginBox.passwordError')"
						:invalid="isPasswordError"
						toggleMask
						required
						:enableValidation="false"
						@enter="submit"
					/>
				</div>
			</div>
			<!--Button remember password -->
			<div class="options-box">
				<div class="remember">
					<input
						type="checkbox"
						id="checkbox"
						v-model="saveCredentials"
						class="hidden-checkbox"
					/>
					<label for="checkbox" class="custom-checkbox">
						{{ $t('loginBox.remember') }} 
						<img class="check" src="/assets/images/check-white.svg" />
					</label>
				</div>
				<div class="forgot-container">
					<button
						class="forgot-link"
						@click="forgot"
						:disabled="buttonsAreDisabled"
					>
						{{ $t('loginBox.forgot') }}
					</button>
				</div>
			</div>
			<button
				class="submit red-button"
				@click="submit"
				:disabled="buttonsAreDisabled"
			>
				{{ $t('loginBox.submit') }}
			</button>
			<!-- Links Sign up -->
			<p class="linkRegistro">
				{{ `${$t('loginBox.doNotAccount')}` }} &nbsp
				<a :href="'/register/1/live-account'">{{ $t('loginBox.signUp') }}</a>
			</p>
		</div>
	</div>
	<Preloader :showModal="showM && !isShowAlert"></Preloader>
</template>

<script>
import TVInputBase from '../../../modules/ui/TVInputBase.vue'
import Preloader from '../../components/Preloader'
import TVInputPassword from '../../../modules/ui/TVInputPassword.vue'
export default {
	name: 'LoginBox',
	components: {
		Preloader,
		TVInputBase,
		TVInputPassword,
	},
	props: {
		auto: Boolean,
		isShowAlert: Boolean,
	},
	computed: {
		isEmailError() {
			return this.submitted && (!this.email || !this.isValidEmail(this.email))
		},
		isPasswordError() {
			return this.submitted && (!this.password || this.password === '')
		},
	},
	data() {
		return {
			pageUrl: process.env.VUE_APP_TRADEVIEW_INDEX + 'open-demo',
			storeCredendials: false,
			email: '',
			password: '',
			passwordFieldType: 'password',
			buttonsAreDisabled: false,
			saveCredentials: false,
			submitted: false,
			showM: false,
			emailErrorMessage: '',
		}
	},
	emits: ['submit', 'forgot'],
	methods: {
		isValidEmail(email) {
			const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
			return regex.test(email)
		},
		lock() {
			this.buttonsAreDisabled = true
		},
		release() {
			this.buttonsAreDisabled = false
		},
		clear() {
			this.email = ''
			this.password = ''
		},
		togglePasswordVisibility() {
			this.passwordFieldType =
				this.passwordFieldType === 'password' ? 'text' : 'password'
		},
		async submit() {
			if (this.auto) {
				this.buttonsAreDisabled = true
			}

			this.submitted = true
			this.emailErrorMessage = ''

			if (!this.isValidEmail(this.email)) {
				this.emailErrorMessage = this.$t('loginBox.emailError')
				this.buttonsAreDisabled = false
				return
			}

			try {
				await this.$emit('submit', this.email, this.password)
				this.buttonsAreDisabled = false
			} catch (error) {
				console.error('Error during submit:', error)
				this.showM = false
				this.buttonsAreDisabled = false
				this.submitted = true
				this.emailErrorMessage = this.$t('loginBox.emailError')
			}
		},
		forgot() {
			this.$router.push('/forgot')
		},
		doFederatedGoogleLogIn() {
			this.emitter.emit('federatedSignIn', {
				provider: 'Google',
				code: null,
				token: null,
			})
		},
		doFederatedFacebookLogIn() {
			this.emitter.emit('federatedSignIn', {
				provider: 'Facebook',
				code: null,
				token: null,
			})
		},
		forceUpdateComponent() {
			this.$forceUpdate()
		},
	},
	mounted() {},
}
</script>
